"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = exports.shouldBeEqualTo = exports.checkUser = void 0;
const __async_1 = __importDefault(require("./_.async"));
function checkUser({ field }) {
    const msg = `Hey! The username ${field.value} is already taken.`;
    // show error if the call does not returns entries
    return (0, __async_1.default)({ user: field.value })
        .then(items => [(items.length === 0), msg]);
}
exports.checkUser = checkUser;
function shouldBeEqualTo(target) {
    return ({ field, form }) => {
        const fieldsAreEquals = (form.$(target).value === field.value);
        return [fieldsAreEquals, `The ${field.label} should be equals to ${form.$(target).label}`];
    };
}
exports.shouldBeEqualTo = shouldBeEqualTo;
function isEmail({ field }) {
    const isValid = (field.value.indexOf('@') > 0);
    return [isValid, `The ${field.label} should be an email address.`];
}
exports.isEmail = isEmail;
